module.exports = __webpack_public_path__ + "static/img/class_30.5f3c53aa.jpg";